import getChats from './get-chats';
import sendChat from './send-chat';

export default {
	getChats,
	sendChat
};
